export default __webpack_public_path__ + "static/media/img-gt-mode-gt-bg-uk_en.96b67785.jpg";